import Axios from "axios";
import React from "react";
import { CMSPath } from "../config/constant";

export const spa_booking_base_url = Axios.create({baseURL: `${CMSPath}/spaWebApplication/rest`});

export const getSpaTreatmentList = async (locationId) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    let payload = {}

    if(locationId){
        payload = {
            "header": {
                "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                "reservationNumber": currentUserInfo[0].reservationNumber,
                "guestToken": currentUserInfo[0].guestToken,
            },
            "payload": {
                "spaLocationId": locationId
            }
        }
    } else {
        payload = {
            "header": {
                "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                "reservationNumber": currentUserInfo[0].reservationNumber,
                "guestToken": currentUserInfo[0].guestToken,
            },
            "payload": {}
        }
    }

    try {
        let data = await spa_booking_base_url.post(`/getSpaTreatments`,payload)
        return data
    } catch (error) {
        return error
    }
    
}


export const searchSpaAvailability = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }
    

    try {
        let data = await spa_booking_base_url.post(`/searchSpaAvailability`,requestPayload)
        return data
    } catch (error) {
        return error
    }

}

export const makeSpaBooking = async (payload) => {
    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await spa_booking_base_url.post(`/saveAppointment`,requestPayload)
        return data
    } catch (error) {
        return error
    }
    
}


export const updateMySpaBooking = async(payload) => {
    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await spa_booking_base_url.post(`/updateAppointment`,requestPayload)
        return data
    } catch (error) {
        return error
    }
}


export const getMySpaBooking = async(payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await spa_booking_base_url.post(`/getAllAppointment`,requestPayload)
        return data
    } catch (error) {
        return error
    }

}


export const cancelMySpaBooking = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await spa_booking_base_url.post(`/cancelAppointment`,requestPayload)
        return data
    } catch (error) {
        return error
    }
}


export const getAddonsForSpa = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    
    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await spa_booking_base_url.post(`/getAddonServices`,requestPayload)
        return data
    } catch (error) {
        return error
    }
}